export const ALERT_TYPES = {
    RESTOCK: 'restock',      // חזר למלאי (היה 0, עכשיו > 0)
    STOCKOUT: 'stockout',    // אזל מהמלאי (היה > 0, עכשיו <= 0)
    TRENDING_UP: 'trendingUp', // עלה בדירוג (B -> A)
    TRENDING_DOWN: 'trendingDown', // ירד בדירוג (A -> B)
    LOW_STOCK: 'lowStock',   // מלאי נמוך חדש (DOI < 14)
};

export const ALERT_CONFIG = {
    [ALERT_TYPES.RESTOCK]: {
        icon: 'PackagePlus',
        color: 'emerald',
        title: 'חזר למלאי',
        bgClass: 'bg-emerald-50 border-emerald-200',
        textClass: 'text-emerald-700',
        iconClass: 'text-emerald-500',
    },
    [ALERT_TYPES.STOCKOUT]: {
        icon: 'PackageX',
        color: 'red',
        title: 'אזל מהמלאי',
        bgClass: 'bg-red-50 border-red-200',
        textClass: 'text-red-700',
        iconClass: 'text-red-500',
    },
    [ALERT_TYPES.TRENDING_UP]: {
        icon: 'TrendingUp',
        color: 'blue',
        title: 'עולה בדירוג',
        bgClass: 'bg-blue-50 border-blue-200',
        textClass: 'text-blue-700',
        iconClass: 'text-blue-500',
    },
    [ALERT_TYPES.TRENDING_DOWN]: {
        icon: 'TrendingDown',
        color: 'amber',
        title: 'ירד בדירוג',
        bgClass: 'bg-amber-50 border-amber-200',
        textClass: 'text-amber-700',
        iconClass: 'text-amber-500',
    },
    [ALERT_TYPES.LOW_STOCK]: {
        icon: 'AlertTriangle',
        color: 'amber',
        title: 'מלאי נמוך',
        bgClass: 'bg-amber-50 border-amber-200',
        textClass: 'text-amber-700',
        iconClass: 'text-amber-500',
    },
};
